/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmd_Go_FieldsInputs */

const en_cmd_go_fields = /** @type {(inputs: Cmd_Go_FieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to fields of this product`)
};

const de_cmd_go_fields = /** @type {(inputs: Cmd_Go_FieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu den Feldern dieses Produkts`)
};

/**
* | output |
* | --- |
* | "Go to fields of this product" |
*
* @param {Cmd_Go_FieldsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cmd_go_fields = /** @type {((inputs?: Cmd_Go_FieldsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmd_Go_FieldsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cmd_go_fields(inputs)
	return en_cmd_go_fields(inputs)
});